import React from 'react';
import { useTranslation } from 'react-i18next';

import { UI_OPERATION_STATUS_REQUEST } from '@uncinc/react-drupal-core';

import useOperationStatus from '../../../../hooks/useOperationStatus';
import Button, { ButtonProps } from '../../../Button';

export interface BuddiesFormSubmitProps extends ButtonProps {
  translationBase: string;
}

const BuddiesFormSubmit: React.FC<BuddiesFormSubmitProps> = (props) => {
  const { translationBase, ...restProps } = props;

  const { t } = useTranslation();
  const status = useOperationStatus('user', 'update');

  return (
    <Button
      {...restProps}
      htmlType="submit"
      buttonState={status === UI_OPERATION_STATUS_REQUEST && 'disabled'}
    >
      {t(`${translationBase}.submit`)}
    </Button>
  );
};

export default BuddiesFormSubmit;
